<template>
  <div
    class="page-header header-filter"
    filter-color="black"
  >
    <div
      class="page-header-image"
      style="background-image: url(static/img/background/gillwell-background.jpg);"
    />
    <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
    <div class="content">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-4 ml-auto mr-auto">
            <ValidationObserver ref="form">
              <form @submit.prevent="save">
                <card type="login">
                  <h3
                    slot="header"
                    class="header text-center"
                  >
                    Password Recovery
                  </h3>
                  <ValidationProvider
                    name="email"
                    rules="required|email"
                    v-slot="{ passed, failed }"
                  >
                    <fg-input
                      type="email"
                      :error="
                        failed ? 'The Email Adress field is required' : null
                      "
                      :has-success="passed"
                      v-model="email"
                      label="Email Address"
                      placeholder=""
                    />
                  </ValidationProvider>
                  <p v-if="sent">
                    If the email address above is a valid user, an email was
                    sent to that address with instructions on how to complete
                    the process.
                  </p>
                  <br>
                  <p-button
                    native-type="button"
                    @click="cancel"
                    slot="footer"
                    type="info"
                    round
                    block
                    class="mb-3"
                  >
                    {{ cancelButtonLabel }}
                  </p-button>
                  <p-button
                    :disabled="disableButtons"
                    native-type="submit"
                    slot="footer"
                    type="warning"
                    round
                    block
                    class="mb-3"
                  >
                    Send Email
                  </p-button>
                </card>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from '@/services/api/user'

export default {
  name: 'PasswordForgot',
  data: function () {
    return {
      email: null,
      sent: false,
      disableButtons: false,
      cancelButtonLabel: 'Cancel'
    }
  },
  mounted: function () {
    this.cancelButtonLabel = 'Cancel'
  },
  methods: {
    cancel: function () {
      this.$router.push('/login')
    },
    save: function () {
      return this.$refs.form.validate().then(res => {
        this.submitForm()
        return res
      })
    },
    submitForm: function () {
      this.disableButtons = true
      return userApi.forgotPassword(this.email).then(response => {
        this.sent = true
        this.cancelButtonLabel = 'Return to Login'
      })
    }
  }
}
</script>
